'use client';

import {
  Flex,
  Accordion,
  AccordionItem,
  AccordionPanel,
} from '@chakra-ui/react';
import { FC } from 'react';
import {
  IFilterGroup,
  IFilterObject,
} from '@/components/Product/Filters/types';
import FilterItems from '@/components/UI/Filter/FilterItems';
import FilterItemsGroupName from '@/components/UI/Filter/FilterItemsGroupName';

interface FilterItemsGroupProps  {
  onToggle?: () => void;
  filters?: IFilterObject[];
  onFiltersChange?: (val: IFilterObject[]) => void;
  filterGroups?: IFilterGroup[];
};
const FilterItemsGroup: FC<FilterItemsGroupProps> = ({
  onToggle,
  filters,
  onFiltersChange,
  filterGroups = [],
}) => {
  return (
    <Accordion
      defaultIndex={filterGroups.map((_, idx) => idx)}
      allowMultiple
      onClick={(e) => e.stopPropagation()}
      gap="1.25rem"
      flexDir="column"
      as={Flex}
    >
      {filterGroups.map((fG) => {
        const { key } = fG;
        return (
          <AccordionItem key={key} border="none">
            {({ isExpanded }) => (
              <>
                <FilterItemsGroupName isExpanded={isExpanded}>
                  {key}
                </FilterItemsGroupName>
                <AccordionPanel mt="1rem" p="0">
                  <FilterItems
                    filterGroup={fG}
                    filters={filters}
                    onFiltersChange={onFiltersChange}
                  />
                </AccordionPanel>
              </>
            )}
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};

export default FilterItemsGroup;
